
const dataLayer = window.dataLayer;
const sentPushes = [];


function pushInternal(eventName, label, onlyOnce, extraProps) {

    const evt = {
        'event': label ? `${eventName}|${label}` : eventName,
    }

    if (extraProps) {
        Object.assign(evt, extraProps);
    }

    if (!dataLayer) {
        console.log("ga: no datalayer (not sent):", evt);
        return;
    }


    if (onlyOnce) {
        if (sentPushes.indexOf(eventName) == -1) {
            dataLayer.push(evt);
            sentPushes.push(eventName);
            console.log("ga: push once:", evt);
        } else {
            console.log("ga: duplicate push (not sent):", evt);
        }
    } else {
        console.log("ga: push:", evt);
        dataLayer.push(evt);
    }
}

function push(eventName, label, extraProps) {
    pushInternal(eventName, label, false, extraProps);
}

function pushOnce(eventName, label, extraProps) {
    pushInternal(eventName, label, true, extraProps);
}

export default {
    push,
    pushOnce
}

